import { makeStyles } from '@material-ui/core/styles';
import { Box, CircularProgress } from '@material-ui/core';
import { Stack } from '@mui/system';

const useStyles = makeStyles((theme) => ({
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    loadingContainerFullScreen: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "90vh"
    }
}));

const LoadingComponent = ({ isFullScreen = false, mensaje = "" }) => {
    const classes = useStyles();

    return (

        (
            isFullScreen ?
                <Stack direction="column" spacing={2} className={classes.loadingContainerFullScreen} >
                    { 
                        mensaje ?
                        <Box>{mensaje}</Box>
                        :
                        <></>
                    }
                    <CircularProgress />
                </Stack >
                :
                <Box className={classes.loadingContainer}>
                    <CircularProgress />
                </Box >
        )

    )
}

export default LoadingComponent;